import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useAdditionalDocumentsCommentsApi Hook
 *
 * Pure API hook for additional documents comment operations.
 * All calls target /api/additional-documents-comments endpoints.
 *
 * @returns {{ addComment: Function, updateComment: Function, deleteComment: Function }}
 */
const useAdditionalDocumentsCommentsApi = () => {
  const addComment = useCallback(
    async ({ requestId, comment, attachedFiles }) => {
      const response = await axiosInstance.post(
        '/api/additional-documents-comments/',
        {
          requestId,
          comment,
          attachedFiles,
        }
      );
      return response.data;
    },
    []
  );

  const updateComment = useCallback(
    async ({
      id,
      comment,
      attachedFilesToAdd,
      attachedFilesToRemove,
      requestId,
    }) => {
      const response = await axiosInstance.put(
        `/api/additional-documents-comments/${id}`,
        {
          comment,
          attachedFilesToAdd,
          attachedFilesToRemove,
          requestId,
        }
      );
      return response.data;
    },
    []
  );

  const deleteComment = useCallback(async ({ id, requestId }) => {
    const response = await axiosInstance.delete(
      `/api/additional-documents-comments/${id}`,
      {
        data: { requestId },
      }
    );
    return response.data;
  }, []);

  return { addComment, updateComment, deleteComment };
};

export default useAdditionalDocumentsCommentsApi;
